/* eslint-disable */
import React, { useContext, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import DashboardZoid from '../components/myVW/DashboardZoid';
import { useMyVW } from '../../context/myVWContext';
import Logger from '../../logger';
import { SessionContext } from '../../context/sessionContext';

const MyVWDashboard: React.FC = () => {
  const [searchParams] = useSearchParams();
  const {
    vwfsToken,
    accountNumber,
    partyId,
    brand,
    country,
    language,
    externalId,
    vin,
    email,
    applyAuthState,
  } = useMyVW();
  const sessionContext = useContext(SessionContext);
  const sessionDetails = sessionContext?.sessionDetails;

  const urlVwfsToken = searchParams.get('vwfsToken') || searchParams.get('token') || '';
  const urlAccountNumber = searchParams.get('accountNumber') || '';
  const urlBrand = searchParams.get('brand') || '';
  const urlCountry = searchParams.get('country') || '';
  
  const source = sessionDetails?.source
  const accessToken = urlVwfsToken || vwfsToken;
  const effectiveAccountNumber = urlAccountNumber || accountNumber;
  const effectiveBrand = urlBrand || brand;
  const effectiveCountry = urlCountry || country;
  const zoidScriptUrl = process.env.REACT_APP_DASHBOARD_ZOID_URL ?? '';
  const zoidFrameworkUrl = process.env.REACT_APP_ZOID_URL ?? '';

  const normalizeDashboardBrand = (brand: string) => (brand.toLowerCase() === 'vw' ? 'VW6' : brand);

  useEffect(() => {
    if (!urlVwfsToken && !urlAccountNumber && !urlBrand && !urlCountry) {
      return;
    }

    const shouldUpdateVwfsToken = Boolean(urlVwfsToken && urlVwfsToken !== vwfsToken);
    const shouldUpdateAccountNumber = Boolean(urlAccountNumber && urlAccountNumber !== accountNumber);
    const shouldUpdateBrand = Boolean(urlBrand && urlBrand !== brand);
    const shouldUpdateCountry = Boolean(urlCountry && urlCountry !== country);

    if (!shouldUpdateVwfsToken && !shouldUpdateAccountNumber && !shouldUpdateBrand && !shouldUpdateCountry) {
      return;
    }

    applyAuthState({
      ...(shouldUpdateVwfsToken ? { vwfsToken: urlVwfsToken } : {}),
      ...(shouldUpdateAccountNumber ? { accountNumber: urlAccountNumber } : {}),
      ...(shouldUpdateBrand ? { brand: urlBrand } : {}),
      ...(shouldUpdateCountry ? { country: urlCountry } : {}),
    });
  }, [accountNumber, applyAuthState, brand, country, urlAccountNumber, urlBrand, urlCountry, urlVwfsToken, vwfsToken]);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== new URL(zoidScriptUrl).origin) {
        return;
      }

      const { data } = event;
      if (data?.type === 'myVWCloseTab') {
        Logger.info('Received myVWCloseTab message from zoid iframe, closing window', "Location ==> /myvw/dashboard", sessionDetails);
        window.close();
      }
    };

    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [zoidScriptUrl]);
  // Fix external ID in case we keep it empty.
  useEffect(() => {
    if (!externalId && partyId) {
      applyAuthState({ externalId: String(partyId) });
    }
  }, [externalId, partyId]);

  return (
    <DashboardZoid
      accessToken={accessToken}
      accountNumber={effectiveAccountNumber}
      brand={normalizeDashboardBrand(effectiveBrand)}
      country={effectiveCountry}
      language={language}
      externalId={externalId}
      vin={vin}
      email={email}
      url={zoidScriptUrl}
      zoidUrl={zoidFrameworkUrl}
      source={source}
    />
  );
};

export default MyVWDashboard;